import styled from '@emotion/styled';

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 300px;
  width: 100%;
`;
